import { Link } from '@tanstack/react-router';
import { t } from '../i18n/lingua.js';

/**
 * Una sezione che il livello di accesso non apre.
 *
 * Ci si arriva solo da un indirizzo scritto a mano o da un collegamento
 * salvato: dal menu la voce non c'è. Si dice com'è, e a chi chiedere.
 */
export function NonPermessa() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">{t('Questa sezione non è fra le tue')}</h1>
          <div className="page-sub">{t('Dipende dal tuo livello di accesso')}</div>
        </div>
      </div>

      <div className="cantiere">
        <h2>{t('Dipende dal tuo livello di accesso')}</h2>
        <p>
          {t(
            'Ogni livello vede le sue voci del menu. Se questa ti serve per lavorare, chiedi a un amministratore di cambiarti il livello.',
          )}
        </p>
        <p>
          <Link to="/">{t('Torna al mio lavoro')}</Link> {t('oppure scegli una voce dal menu.')}
        </p>
      </div>
    </>
  );
}
